import { x, styled } from '@xstyled/styled-components';
import React from 'react';
import { Flex } from '~/ui/flex/Flex';
import { Logo } from '~/ui/logo/Logo';
import { TrainingState, useTrainingStore } from '../state';
import HomeIcon from '~/assets/icons/home.svg';
import { t } from 'ttag';
import { Documents } from '../documents/Documents';
import { select } from '~/lib/select';
import { useLmsAdapter } from '~/lms';
import { SITE_NAME } from '~/lib/a11y/formatDocumentTitle';

const selector = (s: TrainingState) =>
  select(
    s,
    'logoUrl',
    'learnerPortalUrl',
    'featureShowHomeButton',
    'companyName'
  );

export const HomeButton = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;
  padding: 9px;
  border: 1px solid ${p => p.theme.colors.greyMed};
  border-radius: 8px;

  &:focus-visible {
    outline: 2px solid var(--color-accent-dk);
    outline-offset: 2px;
  }
`;

export const Header = ({
  hideHomeIcon = false
}: {
  hideHomeIcon?: boolean;
}) => {
  const { learnerPortalUrl, logoUrl, featureShowHomeButton, companyName } =
    useTrainingStore(selector);
  const lms = useLmsAdapter();
  const logoAlt = companyName?.trim() || SITE_NAME;

  const concedeControl = () => {
    if (lms.isAvailable) {
      setTimeout(() => {
        // give the previous LMS calls a chance to fully complete first
        lms.concedeControl();
      });
    }
  };

  return (
    <Flex alignItems="center" justifyContent="space-between" p="md">
      <x.div w="20" tabIndex={-1} />
      <x.div className="logoStyleForDarkTheme" tabIndex={-1}>
        <Logo src={logoUrl || undefined} height={36} alt={logoAlt} />
      </x.div>
      <x.div display="flex" alignItems="center" gap="sm">
        <Documents />
        {!lms.isAvailable && featureShowHomeButton && !hideHomeIcon && (
          <HomeButton
            target="_blank"
            href={learnerPortalUrl}
            aria-label={t`Home`}
            tabIndex={2}
          >
            <HomeIcon
              aria-hidden="true"
              focusable="false"
              className="icon"
              onClick={concedeControl}
            />
          </HomeButton>
        )}
      </x.div>
    </Flex>
  );
};
